/* eslint-disable react-hooks/exhaustive-deps */
import { isEmpty } from "lodash";
import React, { useState, useEffect } from "react";
import { getConstantsPbks } from "../../apis/code";
import { createSalaryAccount, modifySalaryAccount } from "../../apis/employee/employee-bank";
import useForm from "../../hooks/useForm";
import systemAlert from "../../utils/systemAlert";
import Form from "../Form";
import Modal, { ModalHeader } from "../Modal";

const defaultForm = {
  employeeIdx: "", // 직원 번호
  bankName: "", // 은행 이름
  bankCode: "", // 은행 코드
  bankAccountHolder: "", // 예금주
  bankAccountNo: "", // 계좌 번호
  isMain: false, // 메인 사용 여부
};

const EmployeeBankDetailPopup = ({ open, setOpen, data, submit, employee }) => {
  const [mode, setMode] = useState('create');
  const [fields, setFields] = useState([]);
  const [bankCode, setBankCode] = useState([]);

  const _submit = (form) => {
    if (mode === 'create') {
      //추가
      systemAlert('급여계좌를 추가하시겠습니까?', {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '확인',
            onClick: () => {
              createSalaryAccount(form)
                .then(() => {
                  submit();
                  cancel();
                })
                .catch(() => { })
                .finally(() => { });
            }
          }
        ]
      });
    } else {
      // 수정
      systemAlert('급여계좌를 수정하시겠습니까?', {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '확인',
            onClick: () => {
              modifySalaryAccount(data.accountIdx, form)
                .then(() => {
                  submit();
                  cancel();
                })
                .catch(() => { })
                .finally(() => { });
            }
          }
        ]
      });
    }
  };

  const {
    form,
    setForm,
    errors,
    handleSubmit,
    handleOnChange,
    setOriginForm,
    setValidateFields
  } = useForm(
    defaultForm,
    _submit
  );

  useEffect(() => {
    if (open) {
      _getBankCode();
    }

    setValidateFields(fields);
    setMode(isEmpty(data) ? 'create' : 'modify');
    if (isEmpty(data)) {
      if (!isEmpty(employee)) {
        setForm({
          ...defaultForm,
          employeeIdx: employee.idx
        });

        setOriginForm({
          ...defaultForm,
          employeeIdx: employee.idx
        });
      }
    } else {
      setForm(data);
      setOriginForm(data);
    }
  }, [open, employee, data]);

  const _getBankCode = () => {
    getConstantsPbks().then((res) => {
      setBankCode([...res.data.pbks.map((pbk) => ({
        label: `${pbk.name} (${pbk.fcode})`,
        value: pbk.code,
        ...pbk
      })), {
        code: "090",
        fcode: "090",
        label: "카카오뱅크 (090)",
        value: "090",
        name: "카카오뱅크",
      }]);
    });
  };

  useEffect(() => {
    if (!isEmpty(bankCode)) {
      setFields([
        {
          title: "은행선택",
          key: "code",
          type: "search-select",
          className: "manager-form-search-select",
          defaultValue: bankCode.filter((code) => code.value === data.bankCode) || "",
          options: {
            list: bankCode,
            menuPlacement: "bottom",
          },
          onChange: (data) => {
            setForm({
              ...form,
              bankName: data.name,
              bankCode: data.code,
            });
          },
        },
        {
          title: '은행명',
          key: 'bankName',
          type: 'input',
          required: true,
        },
        {
          title: '은행코드',
          key: 'bankCode',
          type: 'input',
          required: true,
        },
        {
          title: '예금주',
          key: 'bankAccountHolder',
          type: 'input',
          required: true,
        },
        {
          title: '계좌번호',
          key: 'bankAccountNo',
          type: 'input',
          required: true,
        },
        {
          title: '주계좌 설정',
          key: 'isMain',
          type: 'checkbox',
          checked: form.isMain,
          onChange: (checked) => {
            setForm({
              ...form,
              isMain: checked
            });
          }
        }
      ]);
    }
  }, [form, bankCode, data]);

  const cancel = () => {
    setOpen(false);
    setForm(defaultForm);
    setOriginForm(defaultForm);
  };

  return (
    <Modal
      size="md"
      isOpen={open}
      close={cancel}
    >
      <div className="salary-bank-account-modal">
        <ModalHeader>급여계좌 {mode === 'create' ? '등록' : '수정'}</ModalHeader>
        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={mode === 'create' ? '등록' : '수정'}
          submit={handleSubmit}
          cancel={cancel}
        />
      </div>
    </Modal>
  );
};

export default EmployeeBankDetailPopup;
